import { render } from "./InvoiceDetailsStatusBar.vue?vue&type=template&id=40aafb44&scoped=true"
import script from "./InvoiceDetailsStatusBar.vue?vue&type=script&lang=js"
export * from "./InvoiceDetailsStatusBar.vue?vue&type=script&lang=js"

import "./InvoiceDetailsStatusBar.vue?vue&type=style&index=0&id=40aafb44&lang=scss&scoped=true"

import exportComponent from "H:\\_LK\\workInProgress\\invoice-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40aafb44"]])

export default __exports__